// AuthenticationDevicesFunction.js

async function getDeviceDetails(deviceName) {

    const uri = "http://localhost";
    const port = await findAvailablePort(uri, 11100, 11120);

    if (!port) {
        alert("No available port found.");
        return;
    }

    

    const url = `http://localhost:${port}/${deviceName === 'irisbiojini' ? 'BISPL' : 'rd'}/capture`;


    const PIDOPTS = getDevicePidOptions(deviceName);


    if (!PIDOPTS) {
        alert("Device configuration not found");
        return;
    }

    try {
        const responseXml = await sendCaptureRequest(url, PIDOPTS);
        return processCaptureResponse(responseXml, deviceName);
    } catch (error) {
        // console.error(`Error capturing for ${deviceName}:`, error);
        alert("Capture error");
    }
}

function getDevicePidOptions(deviceName) {

    switch (deviceName.toLowerCase()) {
        case 'mantra':
            return `<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" 	 wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" /> </PidOptions>`; // Fill with Mantra options
        case 'startek':
            return `<PidOptions> <Opts fCount=\"1\" fType=\"2\" iCount=\"0\" pCount=\"0\" format=\"0\" pidVer=\"2.0\" timeout=\"20000\" otp=\"\" posh=\"UNKNOWN\" env=\"P\" wadh=\"E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=\" /><CustOpts> <Param name=\"ValidationKey\" value=\"\" /> <Demo></Demo></CustOpts> </PidOptions>`; // Fill with Startek options
        case 'secugen':
            return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" iType="" pCount="0" pType="" format="0" pidVer="2.0" timeout="10000" otp="" env="P" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="/><CustOpts><Param name="ValidationKey" value=""/></CustOpts></PidOptions>`; // Fill with Secugen options
        case 'iritech_10cm_1':
            return `<PidOptions ver='1.0'><Opts fCount='' fType='' iCount='1' iType='0' pCount='' pType='' format='0' pidVer='2.0' timeout='10000' otp='' wadh='8QSrHOmcQhlyjiSpIgCi7o2ugs78w+4jhckNk1jeIJg='  posh='UNKNOWN' env='P'/><CustOpts> <Param name='enable_preview' value='yes' /></CustOpts></PidOptions>`; // Fill with Iritech options
        case 'irishieldu':
            return `<PidOptions ver='1.0'><Opts fCount='' fType='' iCount='1' iType='0' pCount='' pType='' format='0' pidVer='2.0' timeout='10000' otp='' wadh='8QSrHOmcQhlyjiSpIgCi7o2ugs78w+4jhckNk1jeIJg='  posh='UNKNOWN' env='P'/><CustOpts> <Param name='enable_preview' value='yes' /></CustOpts></PidOptions>`; // Fill with Iritech options
        case 'irisbiojini':
            return `<PidOptions ver='1.0'><Opts fCount='' fType='' iCount='1' iType='0' pCount='' pType='' format='0' pidVer='2.0' timeout='10000' otp='' wadh='8QSrHOmcQhlyjiSpIgCi7o2ugs78w+4jhckNk1jeIJg='  posh='UNKNOWN' env='P'/><CustOpts> <Param name='enable_preview' value='yes' /></CustOpts></PidOptions>`; // Fill with Iritech options
        default:
            return null;
    }
}



// let PIDOPTSedit = "<PidOptions ver='1.0'><Opts fCount='' fType='' iCount='1' iType='0' pCount='' pType='' format='0' pidVer='2.0' timeout='10000' otp='' wadh='8QSrHOmcQhlyjiSpIgCi7o2ugs78w+4jhckNk1jeIJg='  posh='UNKNOWN' env='P'/><CustOpts> <Param name='enable_preview' value='yes' /></CustOpts></PidOptions>";
// let PIDOPTSall = "<PidOptions ver='1.0'><Opts fCount='' fType='' iCount='1' iType='0' pCount='' pType='' format='0' pidVer='2.0' timeout='10000' otp=''   posh='UNKNOWN' env='P'/><CustOpts> <Param name='enable_preview' value='yes' /></CustOpts></PidOptions>";
async function findAvailablePort(uri, start, end) {
    for (let i = start; i <= end; i++) {
        const isPortAvailable = await checkPortAvailability(uri, i);
        if (isPortAvailable) {
            return i;
        }
    }
    return null;
}

function checkPortAvailability(uri, port) {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open("RDSERVICE", `${uri}:${port}/`, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                resolve(xhr.status === 200);
            }
        };
        xhr.onerror = () => resolve(false);
        xhr.send();
    });
}

function sendCaptureRequest(url, PIDOPTS) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("CAPTURE", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(xhr.responseText);
                } else {
                    reject(xhr.status);
                }
            }
        };
        xhr.onerror = () => reject("Request error");
        xhr.send(PIDOPTS);
    });
}

function processCaptureResponse(responseXml, deviceName) {
    const xmlDoc = new DOMParser().parseFromString(responseXml, "text/xml");
    const dpId = xmlDoc.querySelector('DeviceInfo');

    let deviceSRLNO = "";
    if (deviceName === 'iritech_10cm_1' || deviceName == 'irishieldu') {
        deviceSRLNO = dpId ? dpId.querySelector('Info[name="srno"], Param[name="srno"],Param[name="serialNumber"],Info[name="serialNumber"]') : null;
    }
    else {
        deviceSRLNO = dpId ? dpId.querySelector('Param[name="srno"]') : null;
    }
    const paramElement = deviceSRLNO;
    const srnoValue = paramElement ? paramElement.getAttribute('value') : null;
    const mi = xmlDoc.querySelector("DeviceInfo")?.getAttribute("mi") || "";

    return {
        srno: srnoValue,
        device_name: dpId.getAttribute("dpId"),
        pid: responseXml,
        mi: mi
    };
}

// Exporting functions if needed
export { getDeviceDetails };
